import {create} from 'zustand';

interface ContractDataImportsTableState {
  page: number;
  rowsPerPage: number;

  setContractDataImportsTablePage: (_: unknown, page: number) => void;
}

export const useContractDataImportsTableStore = create<ContractDataImportsTableState>((set, get) => ({
  page: 0,
  rowsPerPage: 20,

  setContractDataImportsTablePage: (_, page) => set({page}),
}));

export const {setContractDataImportsTablePage} = useContractDataImportsTableStore.getState();
